export default __webpack_public_path__ + "static/media/jkl_excel_logo.7d3a3dac.png";